import { render, staticRenderFns } from "./TicketFlowEdit.vue?vue&type=template&id=cf3a7bfc&scoped=true"
import script from "./TicketFlowEdit.vue?vue&type=script&lang=js"
export * from "./TicketFlowEdit.vue?vue&type=script&lang=js"
import style0 from "./TicketFlowEdit.vue?vue&type=style&index=0&id=cf3a7bfc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3a7bfc",
  null
  
)

export default component.exports